import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
`;

export const Content = styled.div`
  display: block;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: 1100px;
  padding: 0 10px;
`;
